var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.714 7.509c.381.218.381.764 0 .982l-6.857 3.932A.571.571 0 014 11.932V4.068c0-.437.476-.71.857-.491l6.857 3.932z",
    fill: "#000"
  })));
}
SvgPlayingIcon.displayName = 'PlayingIcon';
export default SvgPlayingIcon;